export default {"src":"/_next/static/media/down_bold.2785d8cb.svg","height":24,"width":24};